import { Component, OnInit,ViewChild } from '@angular/core';
import { PurchaseInvoice } from 'app/shared/types/purchase-invoice';
import { Router, ActivatedRoute } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { PurchaseInvoiceService } from 'app/shared/services/purchase-invoice.service';
import { HttpErrorResponse } from '@angular/common/http';
import { NbThemeService } from '@nebular/theme';
import { AuthService } from 'app/shared/services/auth.service';

@Component({
  selector: 'app-good-received-note-list',
  templateUrl: './purchase-invoice-list.component.html',
  styleUrls: ['./purchase-invoice-list.component.css']
})
export class PurchaseInvoiceListComponent implements OnInit {

  displayedColumns: string[] = ['type','grnNo', 'grnDate', 'supplier', 'amount','paid','due','status','createdBy','action'];

  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  dataSource :MatTableDataSource<any>
  searchKey : string;
  isDark: boolean = false;
  grn : any [] =[];

  filteredTypeList : any[]=[];

  crud_access = {
    read: null,
    create: null,
    approve: null,
    delete: null,
    createPmt:null,
   };
 

  constructor(
    private purchaseInvoiceService: PurchaseInvoiceService,
    private router : Router, 
    private route : ActivatedRoute, 
    private themeService: NbThemeService,
    private authService: AuthService,
   ) { }

ngOnInit() {

this.getAllGRN();
this.getControlPermissions();
this.themeService.onThemeChange()
.subscribe(themeName =>{
     this.isDark  = themeName.name ==='dark' ? true : false;
   });

}

getControlPermissions(){
  var data1 = [];
   data1 =  this.authService.controlPermissionArray.filter((el)=>{
    return el.moduleCode ==='PI'
  });
  var data2 = [];
  data2 =  this.authService.controlPermissionArray.filter((el)=>{
   return el.moduleCode ==='PMT'
 });
  if(data1.length > 0){
    this.crud_access.read = data1[0].read;
    this.crud_access.create = data1[0].create;
    this.crud_access.approve = data1[0].approve;
    this.crud_access.delete = data1[0].delete;
  }

  if(data2.length > 0){
    this.crud_access.createPmt = data2[0].create;

  }
}

newButtonClick(){
this.router.navigate(['../purchase-invoice'],{relativeTo : this.route});
}


getAllGRN(){
this.purchaseInvoiceService.getAll()
.subscribe(
(data) => {
        this.grn = data; 
        this.dataSource = new  MatTableDataSource (this.grn);  
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;      
        },
(err) => 
      {
        if(err instanceof HttpErrorResponse){                 
          if(err.status == 401){
            this.router.navigate(['/login']);
          }
        }
        console.log(err);
      });  



}


viewDetailsButtonClick(grnNo : string,type : string){   

  if(type==='Purchase'){
    this.router.navigate(['../purchase-invoice'],{queryParams : {'grnNo':grnNo},relativeTo : this.route}); 
   }else if(type==='Debit Note'){
    this.router.navigate(['../purchase-return'],{queryParams : {'returnNo':grnNo},relativeTo : this.route});       
   } 

}

payButtonClicked(grnNo){  
  this.router.navigate(['../payment'],{queryParams : {'grnNo':grnNo},relativeTo : this.route});            
 }

 checkedChangeRdoButtons(event){
  if(event.value =="All"){
    this.dataSource = new  MatTableDataSource(this.grn);
    this.dataSource.paginator = this.paginator; 
  }
  else if(event.value =="Paid"){
    this.filteredTypeList = this.grn.filter((el)=>{
     return el.Status ===event.value;
   });  
   this.dataSource = new  MatTableDataSource (this.filteredTypeList);
   this.dataSource.paginator = this.paginator; 
  }
  else if(event.value =="Unpaid"){
   this.filteredTypeList = this.grn.filter((el)=>{
     return el.Status ===event.value || el.Status==='Partially paid';
   });
   this.dataSource = new  MatTableDataSource (this.filteredTypeList);
   this.dataSource.paginator = this.paginator; 
 }
}



applyFilter(){
this.dataSource.filter =this.searchKey.trim().toLowerCase();

}
onSearchClear(){
this.searchKey = "";
this.applyFilter();
}



}// end class
